<template>
  <nav class="navbar navbar-light bg-light py-1 py-lg-3" :class="{'fixed-top':fixed}">
    <!-- Desktop logo -->
    <a class="navbar-brand d-none d-lg-block" href="/">
      <img src="@/assets/img/logo.svg" height="40" alt="Hokodo Logo">
      <!--
      <img src="@/assets/img/plus-symbol.png" height="40" alt="in partnership with">
      <img src="@/assets/img/logo-kashflow.svg" height="40" alt="Kashflow logo">
      -->
    </a>

    <!-- Mobile logo -->
    <a class="navbar-brand d-block d-lg-none mr-0" href="/" v-if="showLogo">
      <img src="@/assets/img/logo_monogram.svg" height="35" alt="Hokodo Logo">
    </a>

    <protect-wizard-progress v-if="$route.name != 'landing'" class="flex-grow-1" @showBack="toggleLogo"/>
  </nav>
</template>

<script>
import ProtectWizardProgress from '@/views/ProtectWizard/Progress.vue'
export default {
  name: 'navbar',
  components: {
    ProtectWizardProgress
  },
  props: ['fixed'],
  data: function () {
    return {
      showLogo: true
    }
  },
  methods: {
    toggleLogo (showBack) {
      this.showLogo = !showBack
    }
  }
}
</script>
